import { RefObject, useLayoutEffect, useState } from 'react';

export const useIsTextClamped = (
	refs: RefObject<HTMLElement | null>[],
	contentKey: string
): boolean => {
	const [isClamped, setIsClamped] = useState(false);

	useLayoutEffect(() => {
		const elements = refs
			.map((ref) => ref.current)
			.filter((element): element is HTMLElement => !!element);

		const update = () =>
			setIsClamped(
				elements.some((element) => element.scrollHeight > element.clientHeight + 1)
			);
		update();

		if (typeof ResizeObserver === 'undefined') {
			return;
		}

		const observer = new ResizeObserver(update);
		elements.forEach((element) => observer.observe(element));

		return () => observer.disconnect();
	}, [contentKey]);

	return isClamped;
};
